module.exports = __webpack_public_path__ + "static/media/user_name.9dc2b3e5.svg";